<template>
  <div class="kr-layout-content">
    <!--活动列表-->
    <ul class="act-list">
      <li v-for="(item,index) in content" :key="index" @click="details(item.id)">
        <div class="act-img">
          <img :src="item.pic" alt />
        </div>
        <div class="act-cont">
          <p class="title oneline">{{item.title}}</p>
          <div class="art twoline" v-html="item.content"></div>
          <div class="source">
            <div class="rush">{{item.userName}}</div>
            <span class="time">{{item.createTime}}</span>
          </div>
        </div>
      </li>
    </ul>
    <div v-if="loadmore" class="look-more" @click="newsMore">查看更多</div>
    <p v-if="!loadmore" class="none-more">没有更多了</p>
  </div>
</template>
<script>
import $ from "jquery";
export default {
  //   name: "App",
  data() {
    return {
      content: [],
      loadmore: true,
      curPage: 1,
      totalPage: 0
    };
  },
  methods: {
    getData() {
      this.$http
        .get("/api/006-activityList", {
          params: {
            pageNo: this.curPage,
            limit: 9
          }
        })
        .then(res => {
          // console.log(res, "活动列表");
          if (res.status == 200 && res.data.code == 0) {
            this.content = this.content.concat(res.data.rows);

            if (this.curPage >= res.data.totalPage) {
              this.loadmore = false;
            }
            this.curPage++;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    newsMore() {
      //查看更多
      this.getData();
    },
    details(id) {
      this.$router.push({ path: "/ghDetails", query: { id: id, type: 1 } });
    }
  },
  mounted() {
    this.getData();
  }
};
</script>
<style scoped>
.act-list li{cursor:pointer}
.new-article .art-list li .content .author .name {
  padding-left: 0px;
}
.act-list li:hover img {
  transition: all 0.6s linear;
  transform: scale(1.1, 1.1);
}
/* .act-list li .act-cont .art{height:58px;} */
.look-more {
  margin: 60px auto;
}

.act-list li:hover .act-cont {
  transition: all 0.6s linear;
  box-shadow: 0px 2px 15px 0px rgba(0, 0, 0, 0.4);
}
@media (min-width: 1280px) and (max-width: 1366px) {
  .act-list li {
    width: 31%;
    height: 290px;
    margin: 0px 10px 15px 0px;
  }
}
@media (min-width: 1100px) and (max-width: 1279px) {
  .act-list li {
    height: 260px;
    margin: 0px 10px 15px 0px;
  }
  .act-list li .act-cont .title {
    font-size: 16px;
    margin: 5px 0px 2px;
  }
}
@media (min-width: 800px) and (max-width: 1099px) {
  .act-list li {
    width: 48%;
    height: 270px;
    margin: 0px 10px 15px 0px;
  }
}
@media (min-width: 720px) and (max-width: 799px) {
  .act-list li {
    width: 47%;
    height: 250px;
    margin: 0px 10px 15px 0px;
  }
}
@media (min-width: 640px) and (max-width: 719px) {
  .act-list li {
    width: 47%;
    height: 250px;
    margin: 0px 10px 15px 0px;
  }
}
@media (max-width: 639px) and (min-width: 450px) {
  .act-list li {
    width: 47%;
    height: 235px;
    margin: 0px 10px 15px 0px;
  }
}
@media (min-width: 320px) and (max-width: 414px) {
  .act-list li {
    margin: 0px 0px 15px 0px;
  }
}
</style>